<template>
  <div id="app">
    <navigation></navigation>
    <SearchBar></SearchBar>
    <DeprecationBanner></DeprecationBanner>
    <router-view></router-view>
    <SiteFooter></SiteFooter>
  </div>
</template>

<script>
  import Navigation from './components/Navigation'
  import DeprecationBanner from './components/DeprecationBanner'
  import SearchBar from './components/SearchBar'
  import SiteFooter from './components/SiteFooter'
  // import db from './store/db'
  export default {
    name: 'app',
    components: {
      Navigation,
      SearchBar,
      DeprecationBanner,
      SiteFooter
    },
    beforeCreate () {
      this.$store.dispatch('initCategories')
    }
  }
</script>

<style lang='scss'>
  @import "src/assets/sass/main.scss";
</style>



// WEBPACK FOOTER //
// App.vue?7c8dda09